export default __webpack_public_path__ + "34e0b1ef5f3f95ca6f508e125438d593.svg";